function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { captureResponseRequest, executeWebContainerRequest } from '../../../../reducers/actions/next.best.action.actions';
import { SessionSelectors } from 'invision-core';
import { NOTIFICATION_TIME_LENGTH } from '../../../../customercare.constants';

// NOTE: This is code for a DEMO!  It should not be used as an example for other development work.
var NBAWidgetController = /*#__PURE__*/function () {
  function NBAWidgetController($state, $ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, NBAWidgetController);
    Object.assign(this, {
      $state: $state,
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(NBAWidgetController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(state) {
        return {
          user: SessionSelectors.UserSelector(state)
        };
      };
      var controllerActions = {
        getNextBestAction: executeWebContainerRequest,
        captureResponseRequest: captureResponseRequest
      };
      this.disconnect = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.isExpanded = false;
      this.onOffersPage = false;
      this.isFetchingOffers = false;
      this.pageSwitch = function () {
        if (!_this.onOffersPage) {
          _this.isFetchingOffers = true;
          _this.offerOptions.length = 0;
          _this.actions.getNextBestAction(_this.externalReference, _this.intent, _this.downgradeSelections).then(function (data) {
            Array.prototype.push.apply(_this.offerOptions, data);
            _this.isFetchingOffers = false;
          });
        }
        _this.onOffersPage = !_this.onOffersPage;
      };
      this.clearForm = function () {
        _this.intent = 'up';
        _this.downgradeSelections = [];
      };
      this.onSelect = function (offer) {
        offer.Outcome = 'Accepted';
        _this.actions.captureResponseRequest(_this.externalReference, _this.state.user.login, _this.offerOptions).then(function () {
          _this.uiNotificationService.success("".concat(offer.OfferName, " offer has been selected!"), null, {
            timeOut: NOTIFICATION_TIME_LENGTH
          });
        });
        _this.clearForm();
        _this.onOffersPage = !_this.onOffersPage;
        _this.isExpanded = false;
      };
      this.behaviourOptions = ['Positive', 'Neutral', 'Negative'];
      this.offerOptions = [];
      this.tableData = {
        columnDefs: [{
          field: 'OfferName',
          displayName: 'Offer Name',
          width: 220,
          resizable: false,
          enableSorting: true,
          enableColumnMoving: false
        }, {
          field: 'Group',
          displayName: 'Group',
          width: 105,
          resizable: false,
          enableSorting: false,
          enableColumnMoving: false
        }, {
          field: 'ShortDescription',
          displayName: 'Short Description',
          width: 255,
          resizable: false,
          enableSorting: false,
          enableColumnMoving: false
        }, {
          cellTemplate: require('./behaviour.cell.template.html'),
          field: 'Behaviour',
          displayName: 'Behaviour',
          minWidth: 150,
          resizable: false,
          enableSorting: false,
          enableColumnMoving: false
        }, {
          cellTemplate: require('./outcome.cell.template.html'),
          field: 'Outcome',
          displayName: 'Outcome',
          minWidth: 150,
          resizable: false,
          enableSorting: false,
          enableColumnMoving: false
        }],
        data: this.offerOptions
      };
      this.intent = 'up';
      this.isUpgrade = function () {
        return _this.intent === 'up';
      };
      this.isDowngrade = function () {
        return _this.intent === 'down';
      };
      this.isMoving = function () {
        return _this.intent === 'move';
      };
      this.downgradeSelections = [];
      this.downgradeReasons = ['Sports', 'HD', 'HBO'];
    }
  }, {
    key: "handleExpansion",
    value: function handleExpansion() {
      this.isExpanded = !this.isExpanded;
    }
  }, {
    key: "allowCreate",
    value: function allowCreate(searchValue) {
      return !this.downgradeReasons.find(function (option) {
        return option === searchValue;
      });
    }
  }]);
}();
export default {
  template: require('./next.best.action.html'),
  bindings: {
    externalReference: '<'
  },
  controller: NBAWidgetController,
  controllerAs: 'NBAWidget'
};